@if (!!selectedStock()) {

<div class="hr"></div>

<div class="stock-row title">
  <button class="btn btn-rounded btn-light" (click)="handleSelectStock(null)">
    <img src="assets/icons/back.svg" alt="">
  </button>
  <span class="title">
    {{"MORE DETAILS"|translate}}
  </span>
</div>
<div class="stock-row">
  <span class="title">
    {{"SAP CODE"|translate}}
  </span>
  <span>
    {{selectedStock()?.sapcode}}
  </span>
</div>
<div class="stock-row">
  <span class="title">
    {{"DESCRIPTION"|translate}}
  </span>
  <span>
    {{selectedStock()?.description}}
  </span>
</div>
<div class="stock-row">
  <span class="title">
    {{"PRICE"|translate}}
  </span>
  <span>
    {{sharedService.getFormattedPrice(selectedStock()!.price, selectedStock()!.currency)}}
    @if(selectedStock()?.vatIncluded){
    <span class="taxes fs-6">{{'Including taxes'|translate}}</span>
    }@else {
    <span class="taxes fs-6">{{'Excluding taxes'|translate}}</span>
    }
  </span>
</div>

<div class="stock-row">
  <span class="title">
    {{"BATCH"|translate}}
  </span>
  <span>
    {{selectedStock()?.batch}}
  </span>
</div>
<div class="stock-row">
  <span class="title">
    {{"DETAILS"|translate}}
  </span>
  <span>
    {{selectedStock()?.details}}
  </span>
</div>
<div class="stock-row other separator"><span>{{"OTHER"|translate}}</span></div>



@if(storeStock()){
<app-my-store-stock [storeStock]="storeStock"></app-my-store-stock>
}

}@else {

<div class="stock-row title">
  <span class="title">
    {{"STORES"|translate}}
  </span>
</div>

<div class="stocks">

  @if(batchStock.length > 0){

  @for (stock of batchStock; track $index) {
  <app-batch-card [stock]="stock" (handleSelectStock)="handleSelectStock($event)"></app-batch-card>
  }

  }@else {

  <app-placeholder [message]="'No Store Stock found'|translate"></app-placeholder>

  }

</div>

}
